export default __webpack_public_path__ + "static/media/file-exclamation.14f27631.svg";